import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectEventSubscriptionsState = (state: RootState) =>
  state.eventSubcriptions; // change later

const selectEvents = createSelector(
  selectEventSubscriptionsState,
  (state) => state?.events
);

const selectIsLoading = createSelector(
  selectEventSubscriptionsState,
  (state) => state?.isLoading
);

const selectMeta = createSelector(
  selectEventSubscriptionsState,
  (state) => state?.meta
);

const selectFilters = createSelector(
  selectEventSubscriptionsState,
  (state) => state?.filters
);

const selectDetails = createSelector(
  selectEventSubscriptionsState,
  (state) => state?.eventDetails
);

export const selectors = {
  selectEvents,
  selectIsLoading,
  selectMeta,
  selectFilters,
  selectDetails
};
